import { formatDate } from '@angular/common';

export const toCMDate = (value: any, format: string = 'yyyy-MM-dd', timezone?: string) => {
	const dateString = Date.parse(value);
	if (!dateString) {
		return '';
	}
	return formatDate(dateString, format, 'en', timezone ? timezone : undefined);
};
